/**
 * Placeholder page for company details
 */
import React from 'react';
import FlagEnabledContainer from '../FlagEnabled/FlagEnabledContainer';
import FlagVariationContainer from '../FlagVariation/FlagVariationContainer';

function AboutPage() {
  return (
    <div>
      <h1>About ObjectRocket</h1>
      <p>We host databases.</p>
      <FlagEnabledContainer flagKey="test">
        <p>This text will be shown if the &lsquo;test&rsquo; feature flag is enabled.</p>
      </FlagEnabledContainer>
      <FlagVariationContainer
        flagKey="variation-test"
        defaultValue="no value"
        render={(current) => (
          <p>
            This is a variation flag displays a string indicating if you are logged in as the e2e
            test user:
            {current}
          </p>
        )}
      />
    </div>
  );
}

export default AboutPage;
